import privacyPolicy from "./privacy.vue";

const Privacy = {};
Privacy.install = (Vue) => {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  const PrivacyConstructor = Vue.extend(privacyPolicy);
  // 生成一个该子类的实例
  const instance = new PrivacyConstructor();

  // 将这个实例挂载在我创建的div上
  // 并将此div加入全局挂载点内部
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);

  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  Vue.prototype.$pivacypolicy = (option) => {
    instance.title = option.title;
    instance.content = option.content;
    instance.buttonText = option.button;
    instance.privacyState = true;
    if (option.callback) instance.agreeBack = option.callback;
  };
};
export default Privacy;
